<template>
  <el-pagination
    @size-change="onSizeChange"
    @current-change="onCurrentChange"
    :current-page="pagination.current"
    :page-sizes="pagesizes"
    :page-size="pagination.size"
    background

    :total="total">
  </el-pagination>
</template>

<script>

export default {
  name: 'pagination',

  props: {
    total: {
      type: Number,
      default: 0
    },
    pagination: {
      type: Object,
      default: () => {
        return {current: 1, size: 10}
      }
    },
     pagesizes: {
      type: Array,
      default: () => {
        return [10, 20, 30, 50]
      }
    }
  },

  model: {
    prop: 'pagination',
    event: 'changePagination'
  },

  components:{},

  data () {
    return {

    }
  },

  methods: {
    onCurrentChange(current) {
      this.pagination.current = current;
      this.$emit('onChange')
    },
    onSizeChange(size) {
      this.pagination.size = size;
      this.$emit('onChange')
    },
  },

  computed: {},

  created() {},

  mounted() {},
}
</script>


<style lang='scss'>

</style>
